import { Component } from '@angular/core';

import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-essay-settings',
  templateUrl: 'essay-settings.component.html',
  styleUrls: ['./essay-settings.component.scss', './_essay-settings-theme.component.scss']
})
export class EssaySettingsComponent {
  constructor(public surveyEditorService: SurveyEditorService) {}
}
